import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KeepActions } from 'src/app/common/store/actions/keep.actions';
//import { PostingDialogComponent } from '../posting-dialog/posting-dialog.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectAllPostings } from 'src/app/common/store/state/app.state';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

import { MatIconModule } from '@angular/material/icon';
import { ObjectData } from 'src/app/public/common/models/object-data.model';


import { RentAction, BookingAction } from 'src/app/public/rent/constants/rent-basic-data';
import { KeepAction, JobAction, KeepBasicData } from 'src/app/public/keep/constants/keep-basic-data';
import { PostingAction, PostingStatus, PostingBasicData } from 'src/app/public/keep/constants/posting-basic-data';
import { Posting } from 'src/app/public/keep/models/posting.model';
import { Booking } from 'src/app/public/rent/models/booking.model';
import { Job } from 'src/app/public/keep/models/job.model';

import { Car } from 'src/app/public/car/models/car.model';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-postings',
    templateUrl: './postings.component.html',
    styleUrls: ['./postings.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
export class PostingsComponent {

  //@Input() postings: Posting[] = [];
  @Input() objectSource: ObjectSource = ObjectSource.KEEP;
  @Input() carId: string = "";
  @Input() enableNew: boolean = false;

  postings$: Observable<Posting[]>;
  postings: Posting[] = [];

  PostingStatus = PostingStatus;
  ObjectSource = ObjectSource;

  PostingAction = PostingAction;
  postingActionItems = PostingBasicData.postingActionItems

  constructor(
      private router: Router,
      private store: Store, 
      public dialog: MatDialog) {
      this.postings$ = this.store.select(selectAllPostings(this.objectSource, this.carId))
  }
     
  ngOnInit(): void {

    this.postings$ = this.store.select(selectAllPostings(this.objectSource, this.carId))
          
    this.postings$.subscribe(
      (result: Posting[]) => this.postings = result
    );

  }
  
  openPostingDialog(postingId: number, postingAction?: PostingAction): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.carId, postingId );

    //objectData.objectAction = postingAction;

    //console.log('prop = '+JSON.stringify(carId));
    //const dialogRef = this.dialog.open(PostingDialogComponent, {
    //  data: objectData
    //});

  }

    updatePostingStatus(postingId: number, status: PostingStatus){
  
      //console.log('heyy   '+status.toString());
  
      this.store.dispatch(KeepActions.postingStatusUpdateSubmit ( { postingId: postingId, status: status, objectSource: this.objectSource }));
  
    }
    
    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }

    moneyFormat(dt: string): string{
  
      return AppFunctions.numberWithComma(dt);
    }
    
      executePostingAction(posting: Posting, action: PostingAction){
    
        switch(action) {

          case PostingAction.CREATE, PostingAction.EDIT :{
            this.openPostingDialog(posting.postingId, action )
            break;
          }
          default:{
            this.store.dispatch(KeepActions.postingActionSubmit ( { postingAction: action, posting: posting, objectSource: this.objectSource }));
            break;
          }
        }
      }
    

}
